import { render, staticRenderFns } from "./CartFooterInVenue.vue?vue&type=template&id=18bef868"
import script from "./CartFooterInVenue.vue?vue&type=script&lang=js"
export * from "./CartFooterInVenue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports